import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";

// Components
import Loader from "../../components/common/Loader";
import Menu from "../../components/home1/Menu";
import InnerPageHeader from "../../components/innerpage/InnerPageHeader";

import Map from "../../components/innerpage/contact/Map";
import Footer2 from "../../components/home2/Footer";
import ContactForm from "../../components/innerpage/contact/ContactForm";

function Contact() {
  const { t } = useTranslation();

  const breadcrumbItems = [
    { label: t('pages.contact.breadcrumb') }
  ];

  return (
    <>
      <Helmet>
        {/* CSS Styles */}
        <link
          rel="stylesheet"
          href="/home1/assets/css/home_1_style.css"
        />
        <link
          rel="stylesheet"
          href="/home5_residence/assets/css/home_5_style.css"
        />
        <link
          rel="stylesheet"
          href="/home2/assets/css/home_2_style.css"
        />
        <link rel="stylesheet" href="/innerpages/assets/css/inerpages.css" />

        {/* JS Scripts */}
        <script src="/common/assets/js/common_js.js" defer></script>
        <script src="/home1/assets/js/home_1_scripts.js" defer></script>
       
        <script src="/innerpages/assets/js/innerpages.js" defer></script>

        {/* Meta Tags */}
      </Helmet>

      <div className="home-style1 inner-page-header-active">
        <Loader />
        <Menu />
        <div className="smooth-scroll-content" id="scrollsmoother-container">
          <InnerPageHeader 
            title={t('pages.contact.title')}
            description={t('pages.contact.description')}
            breadcrumbItems={breadcrumbItems}
            backgroundImage="/home1/assets/img/slider/4.jpg"
          />
          <main>
            <div className="mt-50 mb-50">
            <ContactForm/>
            </div>
            <div className="mt-50 mb-50">
              <Map />
            </div>
           
           
            
          </main>
          <Footer2 />
        </div>
      </div>
    </>
  );
}

export default Contact;
